import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {useVersionCheck} from '../hooks/useVersionCheck'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {PermissionProvider} from './pages/contexts/PermissionContext'
import {MenuProvider} from './pages/contexts/MenuContext'

const App = () => {
  // const { VersionModal } = useVersionCheck()
  return (
    <PermissionProvider>
      <MenuProvider>
        <Suspense fallback={<LayoutSplashScreen />}>
          <I18nProvider>
            <LayoutProvider>
              <AuthInit>
                <Outlet />
                <MasterInit />
                {/* <VersionModal /> */}
              </AuthInit>
            </LayoutProvider>
          </I18nProvider>
        </Suspense>
      </MenuProvider>
    </PermissionProvider>
  )
}

export {App}
